class ThreeForTwoBar extends HTMLElement {
  connectedCallback () {
    this.hoopsVariantIds = (this.dataset.hoopsVariants || '').split(',').map(s => +s.trim()).filter(Boolean);
    this.excludeVariantIds = (this.dataset.excludeVariants || '').split(',').map(s => +s.trim()).filter(Boolean);
    this.excludeHandles = (this.dataset.excludeHandles || '').toLowerCase().split(',').map(s => s.trim()).filter(Boolean);

    this.$fill     = this.querySelector('.mg-progress-fill');
    this.$headline = this.querySelector('[data-headline]');
    this.$sub      = this.querySelector('[data-sub]');
    this.$dots     = [
      this.querySelector('.m-item-1'),
      this.querySelector('.m-item-2'),
      this.querySelector('.m-item-3')
    ];

    this.eligible = +(this.dataset.eligible || 0);
    this.render();

    const refresh = () => this.refreshFromCart();
    const debounced = (() => { let t; return () => { clearTimeout(t); t = setTimeout(refresh, 120); }; })();
    
    document.addEventListener('cart:open',    debounced);
    document.addEventListener('cart:refresh', debounced);
    document.addEventListener('cart:updated', debounced);
    
    this.wireDomInstantListeners();
  }

  async refreshFromCart () {
    try {
      const res  = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      this.eligible = this.countItemsExcl(cart);
      this.render();
    } catch (e) { console.error(e); }
  }

  wireDomInstantListeners () {
    const drawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
    if (!drawer) return;

    const instant = () => this.optimisticUpdateFromDOM(drawer);
    drawer.addEventListener('change', instant); 
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('[name="plus"], [name="minus"], [data-remove-item]')) setTimeout(instant, 0);
    });
  }

  optimisticUpdateFromDOM (root) {
    let items = 0;
    const rows = root.querySelectorAll('[data-cart-item], .cart-item, li.cart__row');

    rows.forEach(row => {
      const qty = +(row.querySelector('input[name^="updates"]')?.value || 0);
      let vid = row.dataset.variantId;
      if (!vid) {
         const input = row.querySelector('input[name="id"]');
         if (input) vid = input.value;
      }
      
      const text = (row.textContent || '').toLowerCase();
      const isHoops    = this.hoopsVariantIds.includes(+vid);
      const isExcluded = this.excludeVariantIds.includes(+vid) || this.excludeHandles.some(h => text.includes(h));

      if (!isHoops && !isExcluded) items += qty;
    });

    this.eligible = items;
    this.render();
  }

  countItemsExcl (cart) {
    return cart.items.reduce((n, i) => {
      const isHoops    = this.hoopsVariantIds.includes(i.variant_id);
      const isExcluded = this.excludeVariantIds.includes(i.variant_id) || 
                         this.excludeHandles.some(h => i.product_title.toLowerCase().includes(h));
      if (i.gift_card || isHoops || isExcluded) return n;
      return n + i.quantity;
    }, 0);
  }

  render () {
    const items = this.eligible;
    const capped = Math.min(items, 3);
    const progress = Math.round((capped / 3) * 100); 

    if (items >= 3) {
      this.$headline.textContent = "✨ 3-for-2 Activated!";
      this.$headline.style.color = "#A83930";
      this.$sub.innerHTML = "Lowest priced item is <strong>FREE</strong>.";
      this.classList.add('active-offer');
    } else if (items === 2) {
      // ⚡ REVISED PHRASING
      this.$headline.textContent = "✨ Reward Unlocked!";
      this.$headline.style.color = "#111";
      this.$sub.innerHTML = `Select a 3rd item to get one <strong>FREE</strong>!`;
      this.classList.remove('active-offer');
    } else {
      const need = 3 - items;
      this.$headline.textContent = "✨ 3-for-2 Offer";
      this.$headline.style.color = "#111";
      this.$sub.innerHTML = `Add <strong>${need} more items</strong> to unlock 3-for-2.`;
      this.classList.remove('active-offer');
    }

    if (this.$fill) this.$fill.style.width = `${progress}%`;

    if (this.$dots[0]) this.$dots[0].classList.toggle('reached', items >= 1);
    if (this.$dots[1]) this.$dots[1].classList.toggle('reached', items >= 2);
    if (this.$dots[2]) this.$dots[2].classList.toggle('reached', items >= 3);
  }
}

if (!customElements.get('three-for-two-bar')) {
  customElements.define('three-for-two-bar', ThreeForTwoBar);
}